import withReactContent from 'sweetalert2-react-content';
import './styles.scss';
import Swal from 'sweetalert2';
import { typesMessages } from './typesMessages';
export default function LabelWithHelp({ 
    label, 
    htmlFor, 
    className, 
    typeMessage,
    entity,
    clickable = true 
}) {
    const alertModal = withReactContent(Swal);
    const handleOpenHelp = () => {
    const messageConfig = typesMessages[typeMessage];

    if (!messageConfig) return;

    alertModal.fire({
      icon: messageConfig.icon,
      title: messageConfig.title(entity),
      text: messageConfig.text,
      showConfirmButton: false, 
        showCloseButton: true,    
    });
  };

  return (
    <div className="label">
      <label
        htmlFor={htmlFor}
        className={`label__with-help ${className}`}
      >
        {label}
      </label>

      <button
        type="button"
        className="label__help-icon"
        onClick={clickable ? handleOpenHelp : null}
        aria-label={`Help about ${label}`}
      >
        ?
      </button>
    </div>
  );
}